import React, { useState } from 'react'
import { Button } from '../../../nq-component'
import SelectSearch from '../../../components/SelectSearch'

function CustomFilter({ onSubmit, onCancel }) {
  const [status, setStatus] = useState({ label: '', value: '' })

  function handleSubmit() {
    const where = {}

    if (status?.value) {
      where['status'] = status.value
    }

    onSubmit(where)
  }

  function clearFilters() {
    setStatus({ label: '', value: ''})
    handleSubmit()
  }

  const statusOptions = [
    { label: 'Active', value: 'Active', colorClass: 'btn-outline-success' },
    { label: 'Inactive', value: 'Inactive', colorClass: 'btn-outline-warning' }
  ]

  return (
    <div>
      {/* <div className='mb-3'>
        <label className='form-label fw-bolder'>Name</label>
        <input
          type='text'
          className='form-control'
          placeholder='Enter name...'
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div> */}

      {/* <div className='mb-3'>
        <label className='form-label fw-bolder'>Date</label>
        <input
          type='date'
          className='form-control'
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
      </div> */}
      
      {/* <div className='input-group'>
        <input 
        type='text'
        className='form-control border-end-0 pe-0' 
        placeholder='Select status'
        value={status}
        onChange={(e) => setStatus(e.target.value)}/>
        <button className='btn btn-link' type='button'>
          <i className='bi bi-x'/>
        </button>
      </div> */}

      <div className='mb-3'>
        <label className='form-label fw-bolder'>Status</label>
        <SelectSearch
          type='text' 
          value={status}
          onChange={(selected) => setStatus(selected)}
          options={statusOptions}
          placeholder='Select status'/>
      </div>

      <div className='d-flex justify-content-end align-items-end gap-2 mt-4'>
        <Button className='btn btn-light fw-bolder w-100' onClick={clearFilters}>
          Clear
        </Button>
        <Button className='btn btn-primary fw-bolder text-black w-100' onClick={handleSubmit}>
          Apply
        </Button>
      </div>
    </div>
  )
}

export default CustomFilter
